const BASE_URL = process.env.REACT_APP_API_HOST as string;
export const ApiPath = {
  getOnlineMenuWeb: "/api/get/GetOnlineMenuWeb",
  getOnlineMenuLanguages: "/api/get/GetOnlineMenuLanguages",
  getOnlineMenuCompany: "/api/get/getCompanyInfoWeb",
  setOnlineMenuStatistic: "/api/insert/OnlineMenuStatistic",
  sendVerify: "/api/insert/verifyCode",
  sendOrder: "/api/insert/foodOrder"
};

export const getImageByName = (text: string) => `${BASE_URL}/image/${text}`;
export const getImage = (path: string) => `${BASE_URL}/image?image=${path}`;
